/* ============================================
   NIJII - Advanced Animation Engine v4
   GSAP + ScrollTrigger (loaded via script tags)
   Real brand assets from Shopify CDN
   ============================================ */

(function () {
  'use strict';

  /* ---- Brand Asset CDN URLs ---- */
  var BRAND = {
    icon: 'https://cdn.shopify.com/s/files/1/0995/4354/8218/files/Nijii_Icon_4483fd9e-8685-4dad-b7bc-9a0504cc3c4a.svg?v=1774993446',
    logo1: 'https://cdn.shopify.com/s/files/1/0995/4354/8218/files/Nijii_logo_1_6d0567e7-8fb2-48cd-bd51-39a85a6ba55a.svg?v=1774993446',
    element1: 'https://cdn.shopify.com/s/files/1/0995/4354/8218/files/Nijii_element_1_85d1e10c-4998-45e9-b214-9e29bce98f14.svg?v=1774993446',
    logo2: 'https://cdn.shopify.com/s/files/1/0995/4354/8218/files/Nijii_Logo_2_47a9484c-6cb8-4bea-b505-638bf7ef0363.svg?v=1774993447',
    logoGreen: 'https://cdn.shopify.com/s/files/1/0995/4354/8218/files/Nijii_Logo_Green_e34cdf78-637f-4e0a-985d-de93a904c743.svg?v=1774993447',
    pattern1: 'https://cdn.shopify.com/s/files/1/0995/4354/8218/files/Nijii_pattern_1_0a137553-69dd-4f57-a683-5d332cdb0403.svg?v=1774993447',
    pattern2: 'https://cdn.shopify.com/s/files/1/0995/4354/8218/files/Nijii_pattern_2_6a4ab4b0-a18c-40a7-809f-6fd2046ea0b2.svg?v=1774993447'
  };

  /* Reduced motion check */
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ============================================
     BRAND ELEMENT FACTORY
     Creates floating brand asset images
     ============================================ */
  function createBrandElement(src, size, colorClass) {
    var el = document.createElement('div');
    el.className = 'nijii-brand-el ' + (colorClass || 'nijii-brand-el--pink');
    el.setAttribute('aria-hidden', 'true');
    var img = document.createElement('img');
    img.src = src;
    img.alt = '';
    img.loading = 'lazy';
    img.width = size || 40;
    img.height = size || 40;
    img.style.cssText = 'width:100%;height:auto;display:block;';
    el.appendChild(img);
    return el;
  }

  function injectBrandElements(container, configs) {
    if (!container) return [];
    var canvas = document.createElement('div');
    canvas.className = 'nijii-brand-canvas';
    canvas.setAttribute('aria-hidden', 'true');

    var elements = [];
    configs.forEach(function (cfg) {
      var el = createBrandElement(cfg.src, cfg.size, cfg.color);
      el.style.cssText += 'position:absolute;top:' + cfg.top + ';left:' + cfg.left + ';opacity:' + (cfg.opacity || 0.12) + ';pointer-events:none;will-change:transform;';
      canvas.appendChild(el);
      elements.push(el);
    });

    container.style.position = container.style.position || 'relative';
    container.style.overflow = 'hidden';
    container.insertBefore(canvas, container.firstChild);
    return elements;
  }

  /* ============================================
     INJECT BRAND ELEMENTS INTO ALL SECTIONS
     ============================================ */
  function setupBrandElements() {
    var assets = [BRAND.icon, BRAND.element1, BRAND.pattern1, BRAND.pattern2];

    /* Hero Section */
    var hero = document.querySelector('.nijii-hero');
    if (hero) {
      injectBrandElements(hero, [
        { src: BRAND.icon, size: 70, top: '8%', left: '5%', opacity: 0.10, color: 'nijii-brand-el--white' },
        { src: BRAND.element1, size: 55, top: '65%', left: '88%', opacity: 0.08, color: 'nijii-brand-el--white' },
        { src: BRAND.icon, size: 40, top: '75%', left: '10%', opacity: 0.06, color: 'nijii-brand-el--white' },
        { src: BRAND.element1, size: 30, top: '20%', left: '80%', opacity: 0.07, color: 'nijii-brand-el--white' },
        { src: BRAND.icon, size: 50, top: '45%', left: '92%', opacity: 0.05, color: 'nijii-brand-el--white' }
      ]);
    }

    /* Brand Story Section */
    var story = document.querySelector('.nijii-section-story');
    if (story) {
      injectBrandElements(story, [
        { src: BRAND.icon, size: 60, top: '10%', left: '90%', opacity: 0.10, color: 'nijii-brand-el--green' },
        { src: BRAND.element1, size: 45, top: '70%', left: '5%', opacity: 0.08, color: 'nijii-brand-el--pink' },
        { src: BRAND.icon, size: 35, top: '50%', left: '95%', opacity: 0.06, color: 'nijii-brand-el--green' }
      ]);
    }

    /* Collections Section */
    var collections = document.querySelector('.nijii-section-collections');
    if (collections) {
      injectBrandElements(collections, [
        { src: BRAND.element1, size: 50, top: '5%', left: '3%', opacity: 0.08, color: 'nijii-brand-el--pink' },
        { src: BRAND.icon, size: 40, top: '80%', left: '92%', opacity: 0.07, color: 'nijii-brand-el--green' },
        { src: BRAND.element1, size: 30, top: '40%', left: '50%', opacity: 0.05, color: 'nijii-brand-el--pink' }
      ]);
    }

    /* Features Section (dark bg - use white) */
    var features = document.querySelector('.nijii-section-features');
    if (features) {
      injectBrandElements(features, [
        { src: BRAND.icon, size: 70, top: '8%', left: '92%', opacity: 0.08, color: 'nijii-brand-el--white' },
        { src: BRAND.element1, size: 55, top: '70%', left: '3%', opacity: 0.06, color: 'nijii-brand-el--white' },
        { src: BRAND.icon, size: 35, top: '30%', left: '8%', opacity: 0.05, color: 'nijii-brand-el--white' },
        { src: BRAND.element1, size: 45, top: '85%', left: '88%', opacity: 0.07, color: 'nijii-brand-el--white' }
      ]);
    }

    /* Editorial Sections */
    document.querySelectorAll('.nijii-section-editorial').forEach(function (ed, i) {
      injectBrandElements(ed, [
        { src: BRAND.icon, size: 50, top: '12%', left: i % 2 === 0 ? '90%' : '5%', opacity: 0.08, color: 'nijii-brand-el--pink' },
        { src: BRAND.element1, size: 35, top: '75%', left: i % 2 === 0 ? '8%' : '88%', opacity: 0.06, color: 'nijii-brand-el--green' }
      ]);
    });

    /* Newsletter Section (dark bg) */
    var newsletter = document.querySelector('.nijii-section-newsletter');
    if (newsletter) {
      injectBrandElements(newsletter, [
        { src: BRAND.icon, size: 60, top: '10%', left: '5%', opacity: 0.08, color: 'nijii-brand-el--white' },
        { src: BRAND.element1, size: 50, top: '60%', left: '90%', opacity: 0.07, color: 'nijii-brand-el--white' },
        { src: BRAND.icon, size: 30, top: '80%', left: '15%', opacity: 0.05, color: 'nijii-brand-el--white' }
      ]);
    }

    /* Products Section */
    var products = document.querySelector('.nijii-products');
    if (products) {
      var productParent = products.closest('[id^="shopify-section"]') || products.parentElement;
      injectBrandElements(productParent, [
        { src: BRAND.icon, size: 55, top: '5%', left: '93%', opacity: 0.08, color: 'nijii-brand-el--pink' },
        { src: BRAND.element1, size: 45, top: '85%', left: '4%', opacity: 0.06, color: 'nijii-brand-el--green' }
      ]);
    }
  }

  /* ============================================
     CSS ANIMATIONS (NO GSAP NEEDED)
     These run immediately - no library dependency
     ============================================ */
  function setupCSSAnimations() {
    /* Animate brand elements with CSS keyframes */
    var brandEls = document.querySelectorAll('.nijii-brand-el');
    var animations = [
      'nijii-float-1 8s ease-in-out infinite',
      'nijii-float-2 10s ease-in-out infinite',
      'nijii-float-3 12s ease-in-out infinite',
      'nijii-float-4 9s ease-in-out infinite',
      'nijii-float-5 11s ease-in-out infinite'
    ];

    brandEls.forEach(function (el, i) {
      if (!prefersReducedMotion) {
        el.style.animation = animations[i % animations.length];
        el.style.animationDelay = -(i * 1.5) + 's';
      }
    });
  }

  /* ============================================
     GSAP ANIMATION ENGINE
     All scroll-driven & entrance animations
     ============================================ */
  function initGSAPAnimations() {
    if (typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') return;
    if (prefersReducedMotion) return;

    gsap.registerPlugin(ScrollTrigger);

    /* ---- HERO: CINEMATIC ENTRANCE ---- */
    var heroSection = document.querySelector('.nijii-hero');
    if (heroSection) {
      var heroMedia = heroSection.querySelector('.nijii-hero__media img');
      var heroContent = heroSection.querySelector('.nijii-hero__content');
      var heroLotus = heroSection.querySelector('.nijii-hero__lotus');
      var heroSubtitle = heroSection.querySelector('.nijii-hero__subtitle');
      var heroTitle = heroSection.querySelector('.nijii-hero__title');
      var heroLine = heroSection.querySelector('.nijii-hero__line');
      var heroDesc = heroSection.querySelector('.nijii-hero__desc');
      var heroCta = heroSection.querySelector('.nijii-hero__cta');
      var heroScroll = heroSection.querySelector('.nijii-hero__scroll');

      var heroTl = gsap.timeline({ defaults: { ease: 'power3.out' } });

      if (heroMedia) {
        gsap.set(heroMedia, { scale: 1.2 });
        heroTl.from(heroMedia, { scale: 1.4, opacity: 0, duration: 2, ease: 'power2.out' }, 0);
      }

      if (heroLotus) {
        heroTl.from(heroLotus, { scale: 0, rotation: -90, opacity: 0, duration: 1.2, ease: 'back.out(1.7)' }, 0.4);
      }

      if (heroSubtitle) {
        heroTl.from(heroSubtitle, { y: 30, opacity: 0, duration: 0.8 }, 0.6);
      }

      if (heroTitle) {
        heroTl.from(heroTitle, { y: 50, opacity: 0, duration: 1.2 }, 0.8);
      }

      if (heroLine) {
        gsap.set(heroLine, { transformOrigin: 'left center' });
        heroTl.from(heroLine, { scaleX: 0, duration: 0.8, ease: 'power2.inOut' }, 1.2);
      }

      if (heroDesc) {
        heroTl.from(heroDesc, { y: 25, opacity: 0, duration: 0.8 }, 1.4);
      }

      if (heroCta) {
        heroTl.from(heroCta, { y: 20, opacity: 0, duration: 0.7 }, 1.6);
      }

      if (heroScroll) {
        heroTl.from(heroScroll, { opacity: 0, duration: 0.8 }, 2);
      }

      /* Hero parallax zoom on scroll */
      if (heroMedia) {
        gsap.to(heroMedia, {
          scale: 1.35,
          ease: 'none',
          scrollTrigger: { trigger: heroSection, start: 'top top', end: 'bottom top', scrub: true }
        });
      }

      /* Hero content fade-up on scroll */
      if (heroContent) {
        gsap.to(heroContent, {
          y: -100,
          opacity: 0,
          ease: 'none',
          scrollTrigger: { trigger: heroSection, start: '25% top', end: '75% top', scrub: true }
        });
      }

      /* Animate brand elements on hero with scroll parallax */
      heroSection.querySelectorAll('.nijii-brand-el').forEach(function (el, i) {
        gsap.to(el, {
          y: -(40 + Math.random() * 60),
          rotation: -20 + Math.random() * 40,
          ease: 'none',
          scrollTrigger: { trigger: heroSection, start: 'top top', end: 'bottom top', scrub: 1.5 }
        });
      });
    }

    /* ---- MARQUEE: GSAP-DRIVEN INFINITE SCROLL ---- */
    var marqueeTrack = document.querySelector('.nijii-marquee__track');
    if (marqueeTrack) {
      marqueeTrack.style.animation = 'none';
      gsap.to(marqueeTrack, {
        xPercent: -50,
        ease: 'none',
        duration: 20,
        repeat: -1
      });
    }

    /* ---- BRAND STORY: IMAGE PARALLAX + TEXT STAGGER ---- */
    var storyImg = document.querySelector('.nijii-story__image-wrap img');
    if (storyImg) {
      gsap.to(storyImg, {
        yPercent: -10,
        ease: 'none',
        scrollTrigger: { trigger: '.nijii-section-story', start: 'top bottom', end: 'bottom top', scrub: 1.5 }
      });
    }

    var storyContent = document.querySelector('.nijii-story__content');
    if (storyContent) {
      var storyEls = storyContent.querySelectorAll('.nijii-story__label, .nijii-story__heading, .nijii-story__text, .nijii-story__cta');
      gsap.from(storyEls, {
        y: 50,
        opacity: 0,
        duration: 0.9,
        ease: 'power3.out',
        stagger: 0.15,
        scrollTrigger: { trigger: storyContent, start: 'top 80%', toggleActions: 'play none none none' }
      });
    }

    /* Story floating lotus */
    var storyLotus = document.querySelector('.nijii-story__floating-lotus');
    if (storyLotus) {
      gsap.from(storyLotus, {
        scale: 0,
        rotation: -180,
        opacity: 0,
        duration: 1.2,
        ease: 'elastic.out(1, 0.5)',
        scrollTrigger: { trigger: storyLotus, start: 'top 85%', toggleActions: 'play none none none' }
      });
    }

    /* ---- COLLECTION CARDS: 3D STAGGER REVEAL ---- */
    var collectionCards = document.querySelectorAll('.nijii-collection-card');
    if (collectionCards.length) {
      gsap.from(collectionCards, {
        y: 80,
        opacity: 0,
        rotationY: 8,
        duration: 1,
        ease: 'power3.out',
        stagger: 0.2,
        scrollTrigger: { trigger: collectionCards[0].parentElement, start: 'top 80%', toggleActions: 'play none none none' }
      });
    }

    /* ---- SPLIT-REVEAL FOR PRODUCTS SECTION ---- */
    var productsSection = document.querySelector('.nijii-products');
    if (productsSection) {
      var productParent = productsSection.closest('[id^="shopify-section"]') || productsSection.parentElement;

      /* Create split overlay */
      var splitReveal = document.createElement('div');
      splitReveal.className = 'nijii-split-reveal';
      splitReveal.setAttribute('aria-hidden', 'true');

      var splitLeft = document.createElement('div');
      splitLeft.className = 'nijii-split-reveal__panel nijii-split-reveal__panel--left';
      splitLeft.innerHTML = '<div class="nijii-split-reveal__content"><img src="' + BRAND.icon + '" alt="" class="nijii-split-reveal__icon nijii-brand-el--white"><span class="nijii-split-reveal__text">Our Pieces</span></div>';

      var splitRight = document.createElement('div');
      splitRight.className = 'nijii-split-reveal__panel nijii-split-reveal__panel--right';
      splitRight.innerHTML = '<div class="nijii-split-reveal__content"><img src="' + BRAND.element1 + '" alt="" class="nijii-split-reveal__icon nijii-brand-el--white"><span class="nijii-split-reveal__text">Discover</span></div>';

      /* Scatter small brand elements inside panels */
      [splitLeft, splitRight].forEach(function (panel) {
        for (var i = 0; i < 5; i++) {
          var scatterEl = document.createElement('img');
          scatterEl.src = i % 2 === 0 ? BRAND.icon : BRAND.element1;
          scatterEl.alt = '';
          scatterEl.className = 'nijii-split-scatter nijii-brand-el--white';
          scatterEl.style.cssText = 'position:absolute;width:' + (12 + Math.random() * 25) + 'px;height:auto;top:' + (10 + Math.random() * 80) + '%;left:' + (10 + Math.random() * 80) + '%;opacity:0.12;pointer-events:none;';
          panel.appendChild(scatterEl);
        }
      });

      splitReveal.appendChild(splitLeft);
      splitReveal.appendChild(splitRight);

      productParent.style.position = 'relative';
      productParent.insertBefore(splitReveal, productsSection);

      /* Animate split */
      var splitTl = gsap.timeline({
        scrollTrigger: {
          trigger: productParent,
          start: 'top 80%',
          end: 'top 20%',
          scrub: 0.8
        }
      });

      splitTl
        .to(splitLeft, { xPercent: -105, opacity: 0, ease: 'power3.inOut' }, 0)
        .to(splitRight, { xPercent: 105, opacity: 0, ease: 'power3.inOut' }, 0);

      /* Scatter elements fly outward */
      splitLeft.querySelectorAll('.nijii-split-scatter').forEach(function (el, i) {
        splitTl.to(el, { x: -(50 + i * 20), y: -30 + Math.random() * 60, rotation: -90 + Math.random() * 180, opacity: 0, ease: 'power2.in' }, 0);
      });
      splitRight.querySelectorAll('.nijii-split-scatter').forEach(function (el, i) {
        splitTl.to(el, { x: 50 + i * 20, y: -30 + Math.random() * 60, rotation: -90 + Math.random() * 180, opacity: 0, ease: 'power2.in' }, 0);
      });

      /* Products fly in after split */
      gsap.from(productsSection, {
        opacity: 0,
        y: 50,
        scale: 0.96,
        duration: 1,
        ease: 'power2.out',
        scrollTrigger: { trigger: productParent, start: 'top 40%', toggleActions: 'play none none none' }
      });
    }

    /* ---- PRODUCT CARDS FLY-IN ---- */
    var productSlides = document.querySelectorAll('.nijii-products .swiper-slide');
    if (productSlides.length) {
      gsap.from(productSlides, {
        y: 60,
        opacity: 0,
        scale: 0.92,
        duration: 0.7,
        ease: 'power3.out',
        stagger: 0.1,
        scrollTrigger: { trigger: productSlides[0].parentElement, start: 'top 75%', toggleActions: 'play none none none' }
      });
    }

    /* ---- EDITORIAL: IMAGE MASK REVEAL ---- */
    document.querySelectorAll('.nijii-editorial__media').forEach(function (media) {
      var img = media.querySelector('img');
      if (!img) return;

      gsap.from(media, {
        clipPath: 'inset(0 100% 0 0)',
        duration: 1.4,
        ease: 'power4.inOut',
        scrollTrigger: { trigger: media, start: 'top 78%', toggleActions: 'play none none none' }
      });

      gsap.from(img, {
        scale: 1.25,
        duration: 1.6,
        ease: 'power2.out',
        scrollTrigger: { trigger: media, start: 'top 78%', toggleActions: 'play none none none' }
      });
    });

    /* Editorial text slide-in */
    document.querySelectorAll('.nijii-editorial__content').forEach(function (content) {
      var els = content.querySelectorAll('.nijii-editorial__label, .nijii-editorial__heading, .nijii-editorial__text, .nijii-editorial__cta');
      gsap.from(els, {
        y: 40,
        opacity: 0,
        duration: 0.8,
        ease: 'power3.out',
        stagger: 0.12,
        scrollTrigger: { trigger: content, start: 'top 80%', toggleActions: 'play none none none' }
      });
    });

    /* ---- FEATURES: ICON BLOOM + STAGGER ---- */
    var featureItems = document.querySelectorAll('.nijii-feature-item');
    featureItems.forEach(function (item, i) {
      var icon = item.querySelector('.nijii-feature-item__icon');
      var title = item.querySelector('.nijii-feature-item__title');
      var desc = item.querySelector('.nijii-feature-item__desc');

      var ft = gsap.timeline({
        scrollTrigger: { trigger: item, start: 'top 85%', toggleActions: 'play none none none' }
      });

      if (icon) ft.from(icon, { scale: 0, rotation: -30, opacity: 0, duration: 0.7, ease: 'back.out(2)' }, i * 0.08);
      if (title) ft.from(title, { y: 20, opacity: 0, duration: 0.5 }, i * 0.08 + 0.2);
      if (desc) ft.from(desc, { y: 15, opacity: 0, duration: 0.5 }, i * 0.08 + 0.35);
    });

    /* ---- NEWSLETTER: GLOW ENTRANCE ---- */
    var nlSection = document.querySelector('.nijii-section-newsletter');
    if (nlSection) {
      var nlLotus = nlSection.querySelector('.nijii-newsletter__lotus');
      var nlTitle = nlSection.querySelector('.nijii-newsletter__title');
      var nlText = nlSection.querySelector('.nijii-newsletter__text');
      var nlForm = nlSection.querySelector('.nijii-newsletter__form');

      var nlTl = gsap.timeline({
        scrollTrigger: { trigger: nlSection, start: 'top 75%', toggleActions: 'play none none none' }
      });

      if (nlLotus) nlTl.from(nlLotus, { scale: 0, rotation: -180, opacity: 0, duration: 1.2, ease: 'elastic.out(1, 0.5)' }, 0);
      if (nlTitle) nlTl.from(nlTitle, { y: 40, opacity: 0, duration: 0.8 }, 0.2);
      if (nlText) nlTl.from(nlText, { y: 30, opacity: 0, duration: 0.8 }, 0.35);
      if (nlForm) nlTl.from(nlForm, { y: 25, opacity: 0, duration: 0.8 }, 0.5);
    }

    /* ---- SPLIT-TEXT ON SECTION HEADINGS ---- */
    document.querySelectorAll('.nijii-collections__title, .nijii-features__title, .nijii-newsletter__title').forEach(function (heading) {
      var text = heading.textContent;
      var html = '';
      for (var i = 0; i < text.length; i++) {
        if (text[i] === ' ') {
          html += ' ';
        } else {
          html += '<span class="nijii-char">' + text[i] + '</span>';
        }
      }
      heading.innerHTML = html;
      var chars = heading.querySelectorAll('.nijii-char');

      gsap.from(chars, {
        y: 30,
        opacity: 0,
        rotateX: -60,
        duration: 0.6,
        ease: 'back.out(1.7)',
        stagger: 0.025,
        scrollTrigger: { trigger: heading, start: 'top 85%', toggleActions: 'play none none none' }
      });
    });

    /* ---- ALL BRAND ELEMENTS: SCROLL PARALLAX ---- */
    document.querySelectorAll('.nijii-brand-canvas').forEach(function (canvas) {
      canvas.querySelectorAll('.nijii-brand-el').forEach(function (el, i) {
        var speed = 30 + Math.random() * 60;
        var rot = -30 + Math.random() * 60;
        gsap.to(el, {
          y: -speed,
          rotation: rot,
          ease: 'none',
          scrollTrigger: { trigger: canvas.parentElement, start: 'top bottom', end: 'bottom top', scrub: 1.5 }
        });
      });
    });

    /* ---- SECTION LABEL LINE-DRAW ---- */
    document.querySelectorAll('.nijii-story__label, .nijii-collections__label, .nijii-editorial__label, .nijii-products__label, .nijii-features__label').forEach(function (label) {
      gsap.fromTo(label,
        { '--line-scale': 0 },
        {
          '--line-scale': 1,
          duration: 1,
          ease: 'power2.inOut',
          scrollTrigger: { trigger: label, start: 'top 90%', toggleActions: 'play none none none' }
        }
      );
    });

    /* ---- MAGNETIC CURSOR ON CTA BUTTONS (Desktop only) ---- */
    if (window.innerWidth > 1024) {
      document.querySelectorAll('.nijii-hero__cta, .nijii-story__cta, .nijii-editorial__cta, .nijii-newsletter__btn').forEach(function (btn) {
        btn.addEventListener('mousemove', function (e) {
          var rect = btn.getBoundingClientRect();
          var x = e.clientX - rect.left - rect.width / 2;
          var y = e.clientY - rect.top - rect.height / 2;
          gsap.to(btn, { x: x * 0.25, y: y * 0.25, duration: 0.3, ease: 'power2.out' });
        });
        btn.addEventListener('mouseleave', function () {
          gsap.to(btn, { x: 0, y: 0, duration: 0.5, ease: 'elastic.out(1, 0.3)' });
        });
      });
    }

    /* ---- HEADER LOGO SHRINK ON SCROLL ---- */
    var headerLogo = document.querySelector('.header-logo img, .header__logo img');
    if (headerLogo) {
      gsap.to(headerLogo, {
        scale: 0.85,
        ease: 'none',
        scrollTrigger: { trigger: 'body', start: 'top top', end: '200px top', scrub: true }
      });
    }

    /* ---- REFRESH ON RESIZE ---- */
    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { ScrollTrigger.refresh(); }, 250);
    });

    /* ---- SHOPIFY THEME EDITOR ---- */
    if (typeof Shopify !== 'undefined' && Shopify.designMode) {
      document.addEventListener('shopify:section:load', function () {
        setTimeout(function () { ScrollTrigger.refresh(); }, 300);
      });
    }
  }

  /* ============================================
     BOOT SEQUENCE
     GSAP is loaded synchronously via <script> tags
     in theme.liquid BEFORE this file (which has defer)
     ============================================ */
  function boot() {
    /* Step 1: Inject brand elements immediately */
    setupBrandElements();

    /* Step 2: Start CSS float animations immediately */
    if (!prefersReducedMotion) {
      setupCSSAnimations();
    }

    /* Step 3: Init GSAP scroll animations (GSAP already loaded via script tags) */
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      initGSAPAnimations();
      console.log('Nijii: GSAP animations initialized');
    } else {
      console.warn('Nijii: GSAP not found, CSS animations only');
      document.documentElement.classList.add('nijii-no-gsap');
    }
  }

  /* Run on DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
